'use client';

import * as React from 'react';
import { clsx } from 'clsx';
import { CandidateCardAvatar } from './CandidateCardAvatar';
import styles from './CandidateCardStartup.module.css';

export interface CandidateCardStartupSkill {
  id: number | string;
  name: string;
  type?: string;
  logo?: string;
  emoji?: string;
}

export interface CandidateCardStartupProps extends React.HTMLAttributes<HTMLDivElement> {
  candidate: {
    id: number | string;
    name: string;
    position_title?: string;
    highlights?: string;
    avatar?: string;
    blur?: boolean;
    skills?: CandidateCardStartupSkill[];
  };
  recruiterLogoUrl?: string;
  recruiterName?: string;
  className?: string;
}

export const CandidateCardStartup = React.forwardRef<
  HTMLDivElement,
  CandidateCardStartupProps
>(({ candidate, recruiterLogoUrl, recruiterName, className, ...props }, ref) => {
  const skills = candidate.skills ?? [];

  return (
    <div
      ref={ref}
      id={`card-${candidate.id}`}
      className={clsx(styles.root, className)}
      {...props}
    >
      <div className={styles.card}>
        <div className={styles.top}>
          <div className={styles.avatarWrapper}>
            <CandidateCardAvatar
              id={`card-avatar-${candidate.id}`}
              name={candidate.name}
              src={candidate.avatar}
              blur={candidate.blur}
              size={48}
              className={styles.avatarImage}
              blurClassName={styles.avatarBlurred}
            />
          </div>

          <div className={styles.headings}>
            <h2 className={styles.name}>{candidate.name}</h2>
            <h4 className={styles.title}>{candidate.position_title}</h4>
          </div>

          {recruiterLogoUrl && (
            <div className={styles.recruiterLogo}>
              <img src={recruiterLogoUrl} alt={recruiterName || ''} />
            </div>
          )}
        </div>

        <p className={styles.subtitle}>{candidate.highlights}</p>

        <div className={styles.attributes}>
          {skills.map((item) => (
            <div className={styles.attribute} key={item.id}>
              {item.logo && (
                <img
                  src={item.logo}
                  alt={item.name}
                  title={item.name}
                  className={styles.skillLogo}
                />
              )}
              {item.emoji && <span className={styles.emoji}>{item.emoji}</span>}
              <span
                className={styles.skillName}
                style={{ marginLeft: item.logo || item.emoji ? '8px' : '4px' }}
              >
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

CandidateCardStartup.displayName = 'CandidateCardStartup';

export default CandidateCardStartup;
